import { faIdCard } from '@fortawesome/pro-light-svg-icons'

import { generateUrls } from '@hooks/useOrderBundle'

const generateTabBarItems = (orderBundle) => {
  const urls = generateUrls(orderBundle)
  const { editOrderBundleUrl } = urls

  return [
    {
      icon: faIdCard,
      href: editOrderBundleUrl,
      key: 'details',
      title: orderBundle?.title || 'Order Bundle Details',
    },

  ]
}

export default generateTabBarItems
